import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const CustomMonthYearPicker = ({ label, value, onChange, min, max, disabled }) => {
    // value, min, max are in YYYY-MM format. We need to parse them to Date objects.
    const parseDate = (val) => {
        if (!val) return null;
        const [year, month] = val.split('-');
        if (!year || !month) return null;
        // month is 1-indexed in YYYY-MM, Date constructor expects 0-indexed month
        return new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
    };

    const handleChange = (date) => {
        if (!date) {
            onChange("");
            return;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        onChange(`${year}-${month}`);
    };

    const selectedDate = parseDate(value);
    const minDate = parseDate(min);
    const maxDate = parseDate(max);

    return (
        <div className="flex flex-col gap-1 w-full max-w-sm relative">
            <DatePicker
                selected={selectedDate}
                onChange={handleChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                placeholderText="MM/YYYY"
                className="w-full p-2 border border-gray-300 rounded bg-white cursor-pointer sm:text-left form-control"
            />
        </div>
    );
};
